import { AppContext } from "@Context/common/general/context";
import DeviceFamilies from "@Enums/DeviceFamilies";
import { useContext, useEffect } from "react";

// OneSignal App ID
const oneSignalAppId = 'e75200c1-b7c1-44b8-ae73-cd989c48b664';

// Hoisted interval variable to clear the interval outside useEffect closure
let updateLastActiveTime: any = null;

// Update interval for OneSignal user stats
const osUpdateIntervalMS = 60000;

const OneSignalVRWebService = () => {
    const { state } = useContext(AppContext);

    // Fetch user from OneSignal
    const fetchUserData = async () => {
        try {
            const userData = await fetch(`https://api.onesignal.com/apps/${oneSignalAppId}/users/by/external_id/${state.user.id}`, {
                method: 'GET', 
                headers: {
                    accept: 'application/json'
                }
            }).then(response => response.json()).then(response => {
                console.log(response)
                return Promise.resolve(response);
            });

            const emailSubscription = userData?.subscriptions.find((sub: any) => sub.type === 'Email');
            if(!emailSubscription) {
                console.log('No email subscription found', userData);
                return Promise.resolve();
            }
            const userSessionCount = emailSubscription?.session_count || 0;
        } catch (error) {
            console.error(error);
        }
    }

    // Update session count delta
    const patchUserSessionCount = async () => {
        try {
            await fetch(`https://api.onesignal.com/apps/${oneSignalAppId}/users/by/external_id/${state.user.id}`, {
                method: 'PATCH',
                headers: {accept: 'application/json', 'content-type': 'application/json'},
                body: JSON.stringify({
                    deltas: {
                        session_count: 1
                    }
                })
            });
        } catch (error) {
            console.error(error);
        }
    }

    // Create/Update a new user in OneSignal with the user's email as email subscription type
    const createOneSignalUser = async () => {
        try {
            await fetch(`https://api.onesignal.com/apps/${oneSignalAppId}/users`, {
                method: 'POST',
                headers: {accept: 'application/json', 'content-type': 'application/json'},
                body: JSON.stringify({
                    identity: {external_id: state.user.id},
                    subscriptions: [{
                        type: 'Email', 
                        token: state.user.email,
                        enabled: true,
                        device_os: state.device.isVR ? DeviceFamilies.Oculus : DeviceFamilies.Unknown
                    }]
                })
            });
            // Patch user session count delta
            await patchUserSessionCount();
        } catch (error) {
            console.error(error);
        }
    }

    const updateOneSignalUsageStats = async () => {
        try {
            await fetch(`https://api.onesignal.com/apps/${oneSignalAppId}/users/by/external_id/${state.user.id}`, {
                method: 'PATCH',
                headers: {accept: 'application/json', 'content-type': 'application/json'},
                body: JSON.stringify({
                    properties: {
                        last_active: Number((new Date().getTime() / 1000).toFixed(0))
                    },
                    deltas: {
                        session_time: (osUpdateIntervalMS / 1000)
                    }
                })
            });
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        createOneSignalUser();

        // Start a timer to update the usage stats for user every minute
        updateLastActiveTime = setInterval(() => {
            updateOneSignalUsageStats();
        }, osUpdateIntervalMS);

        return () => {
            // Clear the interval when the component is unmounted
            clearInterval(updateLastActiveTime);
        }
    }, []);

    return (<div id='OneSignalVRWebService' />)
}

export default OneSignalVRWebService;
